export default { "columns":32,
 "image":"forest-tileset.png",
 "imageheight":1024,
 "imagewidth":512,
 "margin":0,
 "name":"forest-tileset",
 "spacing":0,
 "tilecount":2048,
 "tiledversion":"1.11.2",
 "tileheight":16,
 "tiles":[
        {
         "id":0,
         "type":"decal"
        }, 
        {
         "id":1,
         "type":"decal"
        }, 
        {
         "id":2,
         "type":"decal"
        }, 
        {
         "id":4,
         "type":"decal"
        }, 
        {
         "id":5,
         "type":"decal"
        }, 
        {
         "id":6,
         "type":"decal"
        }, 
        {
         "id":8,
         "type":"decal"
        }, 
        {
         "id":10,
         "type":"decal"
        }, 
        {
         "id":11,
         "type":"decal"
        }, 
        {
         "id":12,
         "type":"decal"
        }, 
        {
         "id":13,
         "type":"decal"
        }, 
        {
         "id":14,
         "type":"decal"
        }, 
        {
         "id":15,
         "type":"decal"
        }, 
        {
         "id":16,
         "type":"decal"
        }, 
        {
         "id":17,
         "type":"decal"
        }, 
        {
         "id":32,
         "type":"ground"
        }, 
        {
         "id":33,
         "type":"ground"
        }, 
        {
         "id":34,
         "type":"ground"
        }, 
        {
         "id":36,
         "type":"ground"
        }, 
        {
         "id":37,
         "type":"ground"
        }, 
        {
         "id":38,
         "type":"ground"
        }, 
        {
         "id":40,
         "type":"ground"
        }, 
        {
         "id":42,
         "type":"ground"
        }, 
        {
         "id":43,
         "type":"ground"
        }, 
        {
         "id":44,
         "type":"ground"
        }, 
        {
         "id":45,
         "type":"ground"
        }, 
        {
         "id":46,
         "type":"ground"
        }, 
        {
         "id":47,
         "type":"ground"
        }, 
        {
         "id":48,
         "type":"ground"
        }, 
        {
         "id":49,
         "type":"ground"
        }, 
        {
         "id":58,
         "type":"decal"
        }, 
        {
         "id":59,
         "type":"decal"
        }, 
        {
         "id":64,
         "type":"ground"
        }, 
        {
         "id":65,
         "type":"ground"
        }, 
        {
         "id":66,
         "type":"ground"
        }, 
        {
         "id":72,
         "type":"decal"
        }, 
        {
         "id":74,
         "type":"decal"
        }, 
        {
         "id":75,
         "type":"decal"
        }, 
        {
         "id":76,
         "type":"decal"
        }, 
        {
         "id":78,
         "type":"decal"
        }, 
        {
         "id":79,
         "type":"decal"
        }, 
        {
         "id":80,
         "type":"decal"
        }, 
        {
         "id":82,
         "type":"decal"
        }, 
        {
         "id":83,
         "type":"decal"
        }, 
        {
         "id":85,
         "type":"decal"
        }, 
        {
         "id":86,
         "type":"decal"
        }, 
        {
         "id":87,
         "type":"decal"
        }, 
        {
         "id":90,
         "type":"decal"
        }, 
        {
         "id":91,
         "type":"decal"
        }, 
        {
         "id":92,
         "type":"decal"
        }, 
        {
         "id":96,
         "type":"ground"
        }, 
        {
         "id":97,
         "type":"ground"
        }, 
        {
         "id":98,
         "type":"ground"
        }, 
        {
         "id":104,
         "type":"ground"
        }, 
        {
         "id":106,
         "type":"ground"
        }, 
        {
         "id":107,
         "type":"ground"
        }, 
        {
         "id":108,
         "type":"ground"
        }, 
        {
         "id":110,
         "type":"ground"
        }, 
        {
         "id":111,
         "type":"ground"
        }, 
        {
         "id":112,
         "type":"ground"
        }, 
        {
         "id":114,
         "type":"ground"
        }, 
        {
         "id":115,
         "type":"ground"
        }, 
        {
         "id":117,
         "type":"ground"
        }, 
        {
         "id":118,
         "type":"ground"
        }, 
        {
         "id":119,
         "type":"ground"
        }, 
        {
         "id":122,
         "type":"decal"
        }, 
        {
         "id":123,
         "type":"decal"
        }, 
        {
         "id":128,
         "type":"decal"
        }, 
        {
         "id":129,
         "type":"decal"
        }, 
        {
         "id":130,
         "type":"decal"
        }, 
        {
         "id":131,
         "type":"decal"
        }, 
        {
         "id":132,
         "type":"decal"
        }, 
        {
         "id":133,
         "type":"decal"
        }, 
        {
         "id":134,
         "type":"decal"
        }, 
        {
         "id":138,
         "type":"ground"
        }, 
        {
         "id":139,
         "type":"ground"
        }, 
        {
         "id":140,
         "type":"ground"
        }, 
        {
         "id":142,
         "type":"ground"
        }, 
        {
         "id":143,
         "type":"ground"
        }, 
        {
         "id":144,
         "type":"ground"
        }, 
        {
         "id":146,
         "type":"ground"
        }, 
        {
         "id":147,
         "type":"ground"
        }, 
        {
         "id":149,
         "type":"ground"
        }, 
        {
         "id":150,
         "type":"ground"
        }, 
        {
         "id":151,
         "type":"ground"
        }, 
        {
         "id":154,
         "type":"decal"
        }, 
        {
         "id":155,
         "type":"decal"
        }, 
        {
         "id":156,
         "type":"decal"
        }, 
        {
         "id":168,
         "type":"decal"
        }, 
        {
         "id":170,
         "type":"ground"
        }, 
        {
         "id":171,
         "type":"ground"
        }, 
        {
         "id":172,
         "type":"ground"
        }, 
        {
         "id":174,
         "type":"ground"
        }, 
        {
         "id":175,
         "type":"ground"
        }, 
        {
         "id":176,
         "type":"ground"
        }, 
        {
         "id":178,
         "type":"ground"
        }, 
        {
         "id":179,
         "type":"ground"
        }, 
        {
         "id":181,
         "type":"ground"
        }, 
        {
         "id":182,
         "type":"ground"
        }, 
        {
         "id":183,
         "type":"ground"
        }, 
        {
         "id":186,
         "type":"decal"
        }, 
        {
         "id":187,
         "type":"decal"
        }, 
        {
         "id":188,
         "type":"decal"
        }, 
        {
         "id":192,
         "type":"decal"
        }, 
        {
         "id":193,
         "type":"decal"
        }, 
        {
         "id":194,
         "type":"decal"
        }, 
        {
         "id":195,
         "type":"decal"
        }, 
        {
         "id":196,
         "type":"decal"
        }, 
        {
         "id":197,
         "type":"decal"
        }, 
        {
         "id":200,
         "type":"ground"
        }, 
        {
         "id":218,
         "type":"decal"
        }, 
        {
         "id":219,
         "type":"decal"
        }, 
        {
         "id":220,
         "type":"decal"
        }, 
        {
         "id":224,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagLeft"
        }, 
        {
         "id":225,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagRight"
        }, 
        {
         "id":226,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagLeft"
        }, 
        {
         "id":227,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagLeft"
        }, 
        {
         "id":228,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagRight"
        }, 
        {
         "id":229,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":2,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-8
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagRight"
        }, 
        {
         "id":234,
         "type":"ground"
        }, 
        {
         "id":235,
         "type":"ground"
        }, 
        {
         "id":236,
         "type":"ground"
        }, 
        {
         "id":238,
         "type":"decal"
        }, 
        {
         "id":239,
         "type":"decal"
        }, 
        {
         "id":240,
         "type":"decal"
        }, 
        {
         "id":241,
         "type":"decal"
        }, 
        {
         "id":242,
         "type":"decal"
        }, 
        {
         "id":243,
         "type":"decal"
        }, 
        {
         "id":250,
         "type":"decal"
        }, 
        {
         "id":251,
         "type":"decal"
        }, 
        {
         "id":256,
         "type":"ground"
        }, 
        {
         "id":257,
         "type":"ground"
        }, 
        {
         "id":258,
         "type":"ground"
        }, 
        {
         "id":259,
         "type":"ground"
        }, 
        {
         "id":260,
         "type":"ground"
        }, 
        {
         "id":261,
         "type":"ground"
        }, 
        {
         "id":264,
         "type":"decal"
        }, 
        {
         "id":266,
         "type":"ground"
        }, 
        {
         "id":267,
         "type":"ground"
        }, 
        {
         "id":268,
         "type":"ground"
        }, 
        {
         "id":270,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagLeft"
        }, 
        {
         "id":271,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagRight"
        }, 
        {
         "id":272,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagLeft"
        }, 
        {
         "id":273,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagLeft"
        }, 
        {
         "id":274,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagRight"
        }, 
        {
         "id":275,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-8
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopeDiagRight"
        }, 
        {
         "id":282,
         "type":"decal"
        }, 
        {
         "id":283,
         "type":"decal"
        }, 
        {
         "id":288,
         "type":"ground"
        }, 
        {
         "id":289,
         "type":"ground"
        }, 
        {
         "id":290,
         "type":"ground"
        }, 
        {
         "id":291,
         "type":"ground"
        }, 
        {
         "id":292,
         "type":"ground"
        }, 
        {
         "id":293,
         "type":"ground"
        }, 
        {
         "id":296,
         "type":"platform"
        }, 
        {
         "id":298,
         "type":"ground"
        }, 
        {
         "id":299,
         "type":"ground"
        }, 
        {
         "id":300,
         "type":"ground"
        }, 
        {
         "id":302,
         "type":"ground"
        }, 
        {
         "id":303,
         "type":"ground"
        }, 
        {
         "id":304,
         "type":"ground"
        }, 
        {
         "id":305,
         "type":"ground"
        }, 
        {
         "id":306,
         "type":"ground"
        }, 
        {
         "id":307,
         "type":"ground"
        }, 
        {
         "id":313,
         "type":"decal"
        }, 
        {
         "id":314,
         "type":"decal"
        }, 
        {
         "id":315,
         "type":"decal"
        }, 
        {
         "id":316,
         "type":"decal"
        }, 
        {
         "id":334,
         "type":"ground"
        }, 
        {
         "id":335,
         "type":"ground"
        }, 
        {
         "id":336,
         "type":"ground"
        }, 
        {
         "id":337,
         "type":"ground"
        }, 
        {
         "id":338,
         "type":"ground"
        }, 
        {
         "id":339,
         "type":"ground"
        }, 
        {
         "id":346,
         "type":"decal"
        }, 
        {
         "id":347,
         "type":"decal"
        }, 
        {
         "id":366,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":90,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8.88178419700125e-16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":367,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":180,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1.77635683940025e-15,
                     "y":-1.77635683940025e-15
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":368,
         "type":"ground"
        }, 
        {
         "id":369,
         "type":"ground"
        }, 
        {
         "id":370,
         "type":"ground"
        }, 
        {
         "id":371,
         "type":"ground"
        }, 
        {
         "id":377,
         "type":"decal"
        }, 
        {
         "id":378,
         "type":"decal"
        }, 
        {
         "id":379,
         "type":"decal"
        }, 
        {
         "id":380,
         "type":"decal"
        }, 
        {
         "id":384,
         "type":"decal"
        }, 
        {
         "id":385,
         "type":"decal"
        }, 
        {
         "id":386,
         "type":"decal"
        }, 
        {
         "id":387,
         "type":"decal"
        }, 
        {
         "id":388,
         "type":"decal"
        }, 
        {
         "id":390,
         "type":"decal"
        }, 
        {
         "id":391,
         "type":"decal"
        }, 
        {
         "id":392,
         "type":"decal"
        }, 
        {
         "id":393,
         "type":"decal"
        }, 
        {
         "id":394,
         "type":"decal"
        }, 
        {
         "id":410,
         "type":"decal"
        }, 
        {
         "id":411,
         "type":"decal"
        }, 
        {
         "id":416,
         "type":"decal"
        }, 
        {
         "id":417,
         "type":"decal"
        }, 
        {
         "id":418,
         "type":"decal"
        }, 
        {
         "id":419,
         "type":"decal"
        }, 
        {
         "id":420,
         "type":"decal"
        }, 
        {
         "id":422,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":423,
         "type":"platform"
        }, 
        {
         "id":424,
         "type":"platform"
        }, 
        {
         "id":425,
         "type":"platform"
        }, 
        {
         "id":426,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":441,
         "type":"decal"
        }, 
        {
         "id":442,
         "type":"decal"
        }, 
        {
         "id":443,
         "type":"decal"
        }, 
        {
         "id":444,
         "type":"decal"
        }, 
        {
         "id":448,
         "type":"decal"
        }, 
        {
         "id":449,
         "type":"decal"
        }, 
        {
         "id":450,
         "type":"decal"
        }, 
        {
         "id":451,
         "type":"decal"
        }, 
        {
         "id":452,
         "type":"decal"
        }, 
        {
         "id":454,
         "type":"decal"
        }, 
        {
         "id":455,
         "type":"decal"
        }, 
        {
         "id":456,
         "type":"decal"
        }, 
        {
         "id":457,
         "type":"decal"
        }, 
        {
         "id":458,
         "type":"decal"
        }, 
        {
         "id":461,
         "type":"decal"
        }, 
        {
         "id":462,
         "type":"decal"
        }, 
        {
         "id":465,
         "type":"decal"
        }, 
        {
         "id":466,
         "type":"decal"
        }, 
        {
         "id":482,
         "type":"decal"
        }, 
        {
         "id":483,
         "type":"decal"
        }, 
        {
         "id":485,
         "type":"decal"
        }, 
        {
         "id":486,
         "type":"decal"
        }, 
        {
         "id":491,
         "type":"decal"
        }, 
        {
         "id":492,
         "type":"decal"
        }, 
        {
         "id":493,
         "type":"decal"
        }, 
        {
         "id":494,
         "type":"decal"
        }, 
        {
         "id":495,
         "type":"decal"
        }, 
        {
         "id":496,
         "type":"decal"
        }, 
        {
         "id":497,
         "type":"decal"
        }, 
        {
         "id":498,
         "type":"decal"
        }, 
        {
         "id":499,
         "type":"decal"
        }, 
        {
         "id":500,
         "type":"decal"
        }, 
        {
         "id":502,
         "type":"decal"
        }, 
        {
         "id":503,
         "type":"decal"
        }, 
        {
         "id":510,
         "type":"decal"
        }, 
        {
         "id":511,
         "type":"decal"
        }, 
        {
         "id":512,
         "type":"decal"
        }, 
        {
         "id":513,
         "type":"decal"
        }, 
        {
         "id":514,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagLeft"
        }, 
        {
         "id":515,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagRight"
        }, 
        {
         "id":516,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagLeft"
        }, 
        {
         "id":517,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagLeft"
        }, 
        {
         "id":518,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagRight"
        }, 
        {
         "id":519,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":2,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagRight"
        }, 
        {
         "id":520,
         "type":"decal"
        }, 
        {
         "id":521,
         "type":"decal"
        }, 
        {
         "id":524,
         "type":"platform"
        }, 
        {
         "id":525,
         "type":"platform"
        }, 
        {
         "id":526,
         "type":"platform"
        }, 
        {
         "id":527,
         "type":"platform"
        }, 
        {
         "id":528,
         "type":"platform"
        }, 
        {
         "id":529,
         "type":"platform"
        }, 
        {
         "id":530,
         "type":"platform"
        }, 
        {
         "id":531,
         "type":"platform"
        }, 
        {
         "id":534,
         "type":"decal"
        }, 
        {
         "id":535,
         "type":"decal"
        }, 
        {
         "id":536,
         "type":"decal"
        }, 
        {
         "id":537,
         "type":"decal"
        }, 
        {
         "id":538,
         "type":"decal"
        }, 
        {
         "id":539,
         "type":"decal"
        }, 
        {
         "id":540,
         "type":"decal"
        }, 
        {
         "id":541,
         "type":"decal"
        }, 
        {
         "id":542,
         "type":"decal"
        }, 
        {
         "id":543,
         "type":"decal"
        }, 
        {
         "id":544,
         "type":"platform"
        }, 
        {
         "id":545,
         "type":"platform"
        }, 
        {
         "id":546,
         "type":"decal"
        }, 
        {
         "id":547,
         "type":"decal"
        }, 
        {
         "id":548,
         "type":"decal"
        }, 
        {
         "id":549,
         "type":"decal"
        }, 
        {
         "id":550,
         "type":"decal"
        }, 
        {
         "id":551,
         "type":"decal"
        }, 
        {
         "id":552,
         "type":"platform"
        }, 
        {
         "id":553,
         "type":"platform"
        }, 
        {
         "id":556,
         "type":"decal"
        }, 
        {
         "id":557,
         "type":"decal"
        }, 
        {
         "id":558,
         "type":"decal"
        }, 
        {
         "id":559,
         "type":"decal"
        }, 
        {
         "id":560,
         "type":"decal"
        }, 
        {
         "id":561,
         "type":"decal"
        }, 
        {
         "id":562,
         "type":"decal"
        }, 
        {
         "id":563,
         "type":"decal"
        }, 
        {
         "id":566,
         "type":"decal"
        }, 
        {
         "id":567,
         "type":"decal"
        }, 
        {
         "id":568,
         "type":"decal"
        }, 
        {
         "id":569,
         "type":"decal"
        }, 
        {
         "id":570,
         "type":"decal"
        }, 
        {
         "id":571,
         "type":"decal"
        }, 
        {
         "id":572,
         "type":"decal"
        }, 
        {
         "id":573,
         "type":"decal"
        }, 
        {
         "id":574,
         "type":"decal"
        }, 
        {
         "id":575,
         "type":"decal"
        }, 
        {
         "id":576,
         "type":"decal"
        }, 
        {
         "id":577,
         "type":"decal"
        }, 
        {
         "id":584,
         "type":"decal"
        }, 
        {
         "id":585,
         "type":"decal"
        }, 
        {
         "id":588,
         "type":"decal"
        }, 
        {
         "id":589,
         "type":"decal"
        }, 
        {
         "id":592,
         "type":"decal"
        }, 
        {
         "id":593,
         "type":"decal"
        }, 
        {
         "id":609,
         "type":"decal"
        }, 
        {
         "id":610,
         "type":"decal"
        }, 
        {
         "id":611,
         "type":"decal"
        }, 
        {
         "id":612,
         "type":"decal"
        }, 
        {
         "id":613,
         "type":"decal"
        }, 
        {
         "id":614,
         "type":"decal"
        }, 
        {
         "id":615,
         "type":"decal"
        }, 
        {
         "id":616,
         "type":"decal"
        }, 
        {
         "id":620,
         "type":"decal"
        }, 
        {
         "id":621,
         "type":"platformDiagRight"
        }, 
        {
         "id":622,
         "type":"decal"
        }, 
        {
         "id":623,
         "type":"decal"
        }, 
        {
         "id":624,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagLeft"
        }, 
        {
         "id":625,
         "type":"decal"
        }, 
        {
         "id":631,
         "type":"decal"
        }, 
        {
         "id":632,
         "type":"decal"
        }, 
        {
         "id":633,
         "type":"decal"
        }, 
        {
         "id":634,
         "type":"decal"
        }, 
        {
         "id":635,
         "type":"decal"
        }, 
        {
         "id":636,
         "type":"decal"
        }, 
        {
         "id":637,
         "type":"decal"
        }, 
        {
         "id":638,
         "type":"decal"
        }, 
        {
         "id":639,
         "type":"decal"
        }, 
        {
         "id":641,
         "type":"platform"
        }, 
        {
         "id":642,
         "type":"platform"
        }, 
        {
         "id":643,
         "type":"platform"
        }, 
        {
         "id":644,
         "type":"decal"
        }, 
        {
         "id":645,
         "type":"decal"
        }, 
        {
         "id":646,
         "type":"platform"
        }, 
        {
         "id":647,
         "type":"platform"
        }, 
        {
         "id":648,
         "type":"platform"
        }, 
        {
         "id":652,
         "type":"decal"
        }, 
        {
         "id":653,
         "type":"decal"
        }, 
        {
         "id":654,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagRight"
        }, 
        {
         "id":655,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagLeft"
        }, 
        {
         "id":656,
         "type":"decal"
        }, 
        {
         "id":657,
         "type":"decal"
        }, 
        {
         "id":663,
         "type":"decal"
        }, 
        {
         "id":664,
         "type":"decal"
        }, 
        {
         "id":665,
         "type":"decal"
        }, 
        {
         "id":666,
         "type":"decal"
        }, 
        {
         "id":667,
         "type":"decal"
        }, 
        {
         "id":668,
         "type":"decal"
        }, 
        {
         "id":669,
         "type":"decal"
        }, 
        {
         "id":670,
         "type":"decal"
        }, 
        {
         "id":671,
         "type":"decal"
        }, 
        {
         "id":673,
         "type":"decal"
        }, 
        {
         "id":674,
         "type":"decal"
        }, 
        {
         "id":675,
         "type":"decal"
        }, 
        {
         "id":676,
         "type":"decal"
        }, 
        {
         "id":677,
         "type":"decal"
        }, 
        {
         "id":678,
         "type":"decal"
        }, 
        {
         "id":679,
         "type":"decal"
        }, 
        {
         "id":680,
         "type":"decal"
        }, 
        {
         "id":684,
         "type":"decal"
        }, 
        {
         "id":685,
         "type":"decal"
        }, 
        {
         "id":686,
         "type":"decal"
        }, 
        {
         "id":687,
         "type":"decal"
        }, 
        {
         "id":688,
         "type":"decal"
        }, 
        {
         "id":689,
         "type":"decal"
        }, 
        {
         "id":704,
         "type":"decal"
        }, 
        {
         "id":705,
         "type":"decal"
        }, 
        {
         "id":706,
         "type":"decal"
        }, 
        {
         "id":707,
         "type":"decal"
        }, 
        {
         "id":708,
         "type":"decal"
        }, 
        {
         "id":709,
         "type":"decal"
        }, 
        {
         "id":710,
         "type":"decal"
        }, 
        {
         "id":711,
         "type":"decal"
        }, 
        {
         "id":712,
         "type":"decal"
        }, 
        {
         "id":713,
         "type":"decal"
        }, 
        {
         "id":718,
         "type":"decal"
        }, 
        {
         "id":719,
         "type":"decal"
        }, 
        {
         "id":726,
         "type":"decal"
        }, 
        {
         "id":730,
         "type":"decal"
        }, 
        {
         "id":732,
         "type":"decal"
        }, 
        {
         "id":733,
         "type":"decal"
        }, 
        {
         "id":734,
         "type":"decal"
        }, 
        {
         "id":736,
         "type":"platform"
        }, 
        {
         "id":737,
         "type":"platform"
        }, 
        {
         "id":738,
         "type":"platform"
        }, 
        {
         "id":739,
         "type":"decal"
        }, 
        {
         "id":740,
         "type":"decal"
        }, 
        {
         "id":741,
         "type":"decal"
        }, 
        {
         "id":742,
         "type":"decal"
        }, 
        {
         "id":743,
         "type":"platform"
        }, 
        {
         "id":744,
         "type":"platform"
        }, 
        {
         "id":745,
         "type":"platform"
        }, 
        {
         "id":748,
         "type":"decal"
        }, 
        {
         "id":749,
         "type":"decal"
        }, 
        {
         "id":750,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagLeft"
        }, 
        {
         "id":751,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagRight"
        }, 
        {
         "id":752,
         "type":"decal"
        }, 
        {
         "id":753,
         "type":"decal"
        }, 
        {
         "id":758,
         "type":"decal"
        }, 
        {
         "id":759,
         "type":"decal"
        }, 
        {
         "id":761,
         "type":"decal"
        }, 
        {
         "id":762,
         "type":"decal"
        }, 
        {
         "id":763,
         "type":"decal"
        }, 
        {
         "id":764,
         "type":"decal"
        }, 
        {
         "id":765,
         "type":"decal"
        }, 
        {
         "id":766,
         "type":"decal"
        }, 
        {
         "id":767,
         "type":"decal"
        }, 
        {
         "id":770,
         "type":"decal"
        }, 
        {
         "id":771,
         "type":"decal"
        }, 
        {
         "id":772,
         "type":"decal"
        }, 
        {
         "id":773,
         "type":"decal"
        }, 
        {
         "id":774,
         "type":"decal"
        }, 
        {
         "id":775,
         "type":"decal"
        }, 
        {
         "id":780,
         "type":"decal"
        }, 
        {
         "id":781,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagLeft"
        }, 
        {
         "id":782,
         "type":"decal"
        }, 
        {
         "id":783,
         "type":"decal"
        }, 
        {
         "id":784,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":-16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platformDiagRight"
        }, 
        {
         "id":785,
         "type":"decal"
        }, 
        {
         "id":790,
         "type":"decal"
        }, 
        {
         "id":791,
         "type":"decal"
        }, 
        {
         "id":792,
         "type":"decal"
        }, 
        {
         "id":793,
         "type":"decal"
        }, 
        {
         "id":794,
         "type":"decal"
        }, 
        {
         "id":797,
         "type":"decal"
        }, 
        {
         "id":798,
         "type":"decal"
        }, 
        {
         "id":799,
         "type":"decal"
        }, 
        {
         "id":812,
         "type":"decal"
        }, 
        {
         "id":813,
         "type":"decal"
        }, 
        {
         "id":814,
         "type":"decal"
        }, 
        {
         "id":815,
         "type":"decal"
        }, 
        {
         "id":816,
         "type":"decal"
        }, 
        {
         "id":817,
         "type":"decal"
        }, 
        {
         "id":825,
         "type":"decal"
        }, 
        {
         "id":826,
         "type":"decal"
        }, 
        {
         "id":828,
         "type":"decal"
        }, 
        {
         "id":829,
         "type":"decal"
        }, 
        {
         "id":830,
         "type":"decal"
        }, 
        {
         "id":831,
         "type":"decal"
        }, 
        {
         "id":844,
         "type":"decal"
        }, 
        {
         "id":849,
         "type":"decal"
        }, 
        {
         "id":857,
         "type":"decal"
        }, 
        {
         "id":858,
         "type":"decal"
        }, 
        {
         "id":860,
         "type":"decal"
        }, 
        {
         "id":861,
         "type":"decal"
        }, 
        {
         "id":862,
         "type":"decal"
        }, 
        {
         "id":863,
         "type":"decal"
        }, 
        {
         "id":896,
         "type":"decal"
        }, 
        {
         "id":897,
         "type":"decal"
        }, 
        {
         "id":898,
         "type":"decal"
        }, 
        {
         "id":900,
         "type":"decal"
        }, 
        {
         "id":901,
         "type":"decal"
        }, 
        {
         "id":902,
         "type":"decal"
        }, 
        {
         "id":904,
         "type":"decal"
        }, 
        {
         "id":906,
         "type":"decal"
        }, 
        {
         "id":907,
         "type":"decal"
        }, 
        {
         "id":908,
         "type":"decal"
        }, 
        {
         "id":909,
         "type":"decal"
        }, 
        {
         "id":910,
         "type":"decal"
        }, 
        {
         "id":911,
         "type":"decal"
        }, 
        {
         "id":912,
         "type":"decal"
        }, 
        {
         "id":913,
         "type":"decal"
        }, 
        {
         "id":928,
         "type":"decal"
        }, 
        {
         "id":929,
         "type":"decal"
        }, 
        {
         "id":930,
         "type":"decal"
        }, 
        {
         "id":932,
         "type":"decal"
        }, 
        {
         "id":933,
         "type":"decal"
        }, 
        {
         "id":934,
         "type":"decal"
        }, 
        {
         "id":936,
         "type":"decal"
        }, 
        {
         "id":938,
         "type":"decal"
        }, 
        {
         "id":939,
         "type":"decal"
        }, 
        {
         "id":940,
         "type":"decal"
        }, 
        {
         "id":941,
         "type":"decal"
        }, 
        {
         "id":942,
         "type":"decal"
        }, 
        {
         "id":943,
         "type":"decal"
        }, 
        {
         "id":944,
         "type":"decal"
        }, 
        {
         "id":945,
         "type":"decal"
        }, 
        {
         "id":960,
         "type":"decal"
        }, 
        {
         "id":961,
         "type":"decal"
        }, 
        {
         "id":962,
         "type":"decal"
        }, 
        {
         "id":968,
         "type":"decal"
        }, 
        {
         "id":970,
         "type":"decal"
        }, 
        {
         "id":971,
         "type":"decal"
        }, 
        {
         "id":972,
         "type":"decal"
        }, 
        {
         "id":974,
         "type":"decal"
        }, 
        {
         "id":975,
         "type":"decal"
        }, 
        {
         "id":976,
         "type":"decal"
        }, 
        {
         "id":978,
         "type":"decal"
        }, 
        {
         "id":979,
         "type":"decal"
        }, 
        {
         "id":981,
         "type":"decal"
        }, 
        {
         "id":982,
         "type":"decal"
        }, 
        {
         "id":983,
         "type":"decal"
        }, 
        {
         "id":992,
         "type":"decal"
        }, 
        {
         "id":993,
         "type":"decal"
        }, 
        {
         "id":994,
         "type":"decal"
        }, 
        {
         "id":1000,
         "type":"decal"
        }, 
        {
         "id":1002,
         "type":"decal"
        }, 
        {
         "id":1003,
         "type":"decal"
        }, 
        {
         "id":1004,
         "type":"decal"
        }, 
        {
         "id":1006,
         "type":"decal"
        }, 
        {
         "id":1007,
         "type":"decal"
        }, 
        {
         "id":1008,
         "type":"decal"
        }, 
        {
         "id":1010,
         "type":"decal"
        }, 
        {
         "id":1011,
         "type":"decal"
        }, 
        {
         "id":1013,
         "type":"decal"
        }, 
        {
         "id":1014,
         "type":"decal"
        }, 
        {
         "id":1015,
         "type":"decal"
        }, 
        {
         "id":1024,
         "type":"decal"
        }, 
        {
         "id":1025,
         "type":"decal"
        }, 
        {
         "id":1026,
         "type":"decal"
        }, 
        {
         "id":1027,
         "type":"decal"
        }, 
        {
         "id":1028,
         "type":"decal"
        }, 
        {
         "id":1029,
         "type":"decal"
        }, 
        {
         "id":1030,
         "type":"decal"
        }, 
        {
         "id":1034,
         "type":"decal"
        }, 
        {
         "id":1035,
         "type":"decal"
        }, 
        {
         "id":1036,
         "type":"decal"
        }, 
        {
         "id":1038,
         "type":"decal"
        }, 
        {
         "id":1039,
         "type":"decal"
        }, 
        {
         "id":1040,
         "type":"decal"
        }, 
        {
         "id":1042,
         "type":"decal"
        }, 
        {
         "id":1043,
         "type":"decal"
        }, 
        {
         "id":1045,
         "type":"decal"
        }, 
        {
         "id":1046,
         "type":"decal"
        }, 
        {
         "id":1047,
         "type":"decal"
        }, 
        {
         "id":1064,
         "type":"decal"
        }, 
        {
         "id":1066,
         "type":"decal"
        }, 
        {
         "id":1067,
         "type":"decal"
        }, 
        {
         "id":1068,
         "type":"decal"
        }, 
        {
         "id":1070,
         "type":"decal"
        }, 
        {
         "id":1071,
         "type":"decal"
        }, 
        {
         "id":1072,
         "type":"decal"
        }, 
        {
         "id":1074,
         "type":"decal"
        }, 
        {
         "id":1075,
         "type":"decal"
        }, 
        {
         "id":1077,
         "type":"decal"
        }, 
        {
         "id":1078,
         "type":"decal"
        }, 
        {
         "id":1079,
         "type":"decal"
        }, 
        {
         "id":1088,
         "type":"decal"
        }, 
        {
         "id":1089,
         "type":"decal"
        }, 
        {
         "id":1090,
         "type":"decal"
        }, 
        {
         "id":1091,
         "type":"decal"
        }, 
        {
         "id":1092,
         "type":"decal"
        }, 
        {
         "id":1093,
         "type":"decal"
        }, 
        {
         "id":1096,
         "type":"decal"
        }, 
        {
         "id":1106,
         "type":"decal"
        }, 
        {
         "id":1107,
         "type":"decal"
        }, 
        {
         "id":1109,
         "type":"decal"
        }, 
        {
         "id":1110,
         "type":"decal"
        }, 
        {
         "id":1111,
         "type":"decal"
        }, 
        {
         "id":1120,
         "type":"decal"
        }, 
        {
         "id":1121,
         "type":"decal"
        }, 
        {
         "id":1122,
         "type":"decal"
        }, 
        {
         "id":1123,
         "type":"decal"
        }, 
        {
         "id":1124,
         "type":"decal"
        }, 
        {
         "id":1125,
         "type":"decal"
        }, 
        {
         "id":1130,
         "type":"decal"
        }, 
        {
         "id":1131,
         "type":"decal"
        }, 
        {
         "id":1132,
         "type":"decal"
        }, 
        {
         "id":1134,
         "type":"decal"
        }, 
        {
         "id":1135,
         "type":"decal"
        }, 
        {
         "id":1136,
         "type":"decal"
        }, 
        {
         "id":1137,
         "type":"decal"
        }, 
        {
         "id":1138,
         "type":"decal"
        }, 
        {
         "id":1139,
         "type":"decal"
        }, 
        {
         "id":1152,
         "type":"decal"
        }, 
        {
         "id":1153,
         "type":"decal"
        }, 
        {
         "id":1154,
         "type":"decal"
        }, 
        {
         "id":1155,
         "type":"decal"
        }, 
        {
         "id":1156,
         "type":"decal"
        }, 
        {
         "id":1157,
         "type":"decal"
        }, 
        {
         "id":1162,
         "type":"decal"
        }, 
        {
         "id":1163,
         "type":"decal"
        }, 
        {
         "id":1164,
         "type":"decal"
        }, 
        {
         "id":1166,
         "type":"decal"
        }, 
        {
         "id":1167,
         "type":"decal"
        }, 
        {
         "id":1168,
         "type":"decal"
        }, 
        {
         "id":1169,
         "type":"decal"
        }, 
        {
         "id":1170,
         "type":"decal"
        }, 
        {
         "id":1171,
         "type":"decal"
        }, 
        {
         "id":1184,
         "type":"decal"
        }, 
        {
         "id":1185,
         "type":"decal"
        }, 
        {
         "id":1186,
         "type":"decal"
        }, 
        {
         "id":1187,
         "type":"decal"
        }, 
        {
         "id":1188,
         "type":"decal"
        }, 
        {
         "id":1189,
         "type":"decal"
        }, 
        {
         "id":1194,
         "type":"decal"
        }, 
        {
         "id":1195,
         "type":"decal"
        }, 
        {
         "id":1196,
         "type":"decal"
        }, 
        {
         "id":1198,
         "type":"decal"
        }, 
        {
         "id":1199,
         "type":"decal"
        }, 
        {
         "id":1200,
         "type":"decal"
        }, 
        {
         "id":1201,
         "type":"decal"
        }, 
        {
         "id":1202,
         "type":"decal"
        }, 
        {
         "id":1203,
         "type":"decal"
        }, 
        {
         "id":1216,
         "type":"decal"
        }, 
        {
         "id":1217,
         "type":"decal"
        }, 
        {
         "id":1218,
         "type":"decal"
        }, 
        {
         "id":1219,
         "type":"decal"
        }, 
        {
         "id":1220,
         "type":"decal"
        }, 
        {
         "id":1221,
         "type":"decal"
        }, 
        {
         "id":1230,
         "type":"decal"
        }, 
        {
         "id":1231,
         "type":"decal"
        }, 
        {
         "id":1232,
         "type":"decal"
        }, 
        {
         "id":1233,
         "type":"decal"
        }, 
        {
         "id":1234,
         "type":"decal"
        }, 
        {
         "id":1235,
         "type":"decal"
        }, 
        {
         "id":1262,
         "type":"decal"
        }, 
        {
         "id":1263,
         "type":"decal"
        }, 
        {
         "id":1264,
         "type":"decal"
        }, 
        {
         "id":1265,
         "type":"decal"
        }, 
        {
         "id":1266,
         "type":"decal"
        }, 
        {
         "id":1267,
         "type":"decal"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};